/**
 * Masonry layout over a CSS grid, keeping DOM order left to right.
 *
 * The container is a normal CSS grid (columns come from its Tailwind classes,
 * so breakpoints stay in the markup). Rows are made 1px tall and every direct
 * child spans as many rows as its own height, so each item sits right under
 * the previous one in its column. Without JS the grid still works, just with
 * rows of equal-top items.
 *
 * @param {HTMLElement} container Grid element whose children are the tiles.
 */
export function initMasonry( container ) {
	container.style.gridAutoRows = '1px';
	container.style.rowGap = '0px';

	const layout = () => {
		const items = Array.from( container.children );

		// Reset first so heights are measured at their natural size.
		items.forEach( ( item ) => {
			item.style.gridRowEnd = '';
		} );
		items.forEach( ( item ) => {
			const height = Math.ceil( item.getBoundingClientRect().height );
			item.style.gridRowEnd = `span ${ height }`;
		} );
	};

	layout();

	const observer = new ResizeObserver( layout );
	observer.observe( container );
	// Late-loading fonts change tile heights without resizing the container.
	if ( document.fonts ) {
		document.fonts.ready.then( layout );
		document.fonts.addEventListener( 'loadingdone', layout );
	}
}
